import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import cc from "./controlcentre.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SkeletonDataTable } from "../../../components/Loader/Loader.jsx";
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import { useControlcentre } from "../../../Hooks/Features/ControlCentre/useControlcentre.js";
import { Dialog } from "primereact/dialog";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { TreeTable } from "primereact/treetable";
import CommonFilterDropdown from "../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx";
export default function ControlCentre(props) {
  const { checkPermission } = useCommon();  
  const {
    filterValues, setFilterValues, tagRef, User, usercategory, savePermisson, loader, treeData, header, headerTemplate, assignGridTemplate, assignGridBodyTemplate, assignTemplate,
    assignPermission, revokeGridTemplate, revokeGridBodyTemplate, RevokeTemplate, categoryPopup, setCategoryPopup, popupData, popupDataSelected, handlePopupUserSelected, handlePopupSave, handleClose, globalFilter, expandedKeys, setExpandedKeys } = useControlcentre(props);



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <h5>Control Center</h5>
        </div>
        <div className="col-md-4">
          <span
            ref={() => checkPermission("ControlCentre", tagRef)}
            className="w30"
          >
            <span
              ref={tagRef}
              id='{"tabname": "ControlCentre", "data": "controlcenter_assign_revoke_grid"}'
            >
              <CommonFilterDropdown
                fields={[{ key: "users", label: "Select a User", col: 6, type: 'dropdown', onHide: () => { setFilterValues(prev => ({ ...prev, user_category: null, apiCall: true, type: "user" })) } },
                { key: "user_category", label: "Select Category", col: 6, type: "dropdown", onHide: () => { setFilterValues(prev => ({ ...prev, users: null, apiCall: true, type: "category" })) } }
                ]}
                filterValues={filterValues}
                setFilterValues={setFilterValues}
              />
            </span>
          </span>
        </div>

        <div className="col-md-6 text-right">
          <span ref={() => checkPermission("ControlCentre", tagRef)}>
            <span
              ref={tagRef}
              id='{"tabname": "ControlCentre", "data": "controlcenter_assign_revoke_grid"}'
            >
              <button className={cc.buttn} onClick={savePermisson}>
                <FontAwesomeIcon icon="fa-solid fa-floppy-disk" /> Save
              </button>
            </span>
          </span>
        </div>
      </div>
      <hr></hr>
      <div className="row">

        <div className="col-6 left-cc">
          {loader ? (
            <SkeletonDataTable numSkeletons={25} />
          ) : (
            <div ref={() => checkPermission("ControlCentre", tagRef)}>
              <div
                ref={tagRef}
                id='{"tabname": "ControlCentre", "data": "control_center_tab"}'
              >
                <TreeTable
                  globalFilter={globalFilter}
                  filterMode="lenient"
                  value={treeData}
                  header={header}
                  tableStyle={{ minWidth: "100%" }}
                  expandedKeys={expandedKeys}
                  onToggle={(e) => setExpandedKeys(e.value)}
                >
                  <Column
                    field="resource_name"
                    header="Resource Name"
                    style={{
                      width: "41%",
                      maxWidth: "41%",
                      wordBreak: "break-all",
                    }}
                    expander
                  ></Column>
                  <Column
                    field="resource_key"
                    header="Resource Key"
                    style={{
                      width: "35%",
                      maxWidth: "35%",
                      wordBreak: "break-all",
                    }}
                    body={(rowData) => {
                      const data = rowData?.data?.resource_key;
                      return <span>{data}</span>;
                    }}
                  ></Column>
                  <Column
                    field="display"
                    header="View"
                    body={assignGridTemplate}
                    style={{
                      width: "8%",
                      textAlign: "center",
                      maxWidth: "8%",
                      wordBreak: "break-all",
                    }}
                  ></Column>
                  <Column
                    field="edit"
                    header="Editable"
                    body={assignGridBodyTemplate}
                    style={{
                      width: "10%",
                      textAlign: "center",
                      maxWidth: "10%",
                      wordBreak: "break-all",
                    }}
                  ></Column>
                  <Column
                    field="assign_revoke"
                    header="+/-"
                    body={assignTemplate}
                    style={{
                      width: "6%",
                      textAlign: "center",
                      maxWidth: "6%",
                      wordBreak: "break-all",
                    }}
                  ></Column>
                </TreeTable>
              </div>
            </div>
          )}
        </div>
        <div
          className="col-6"
          ref={() => checkPermission("ControlCentre", tagRef)}
        >
          <div
            ref={tagRef}
            id='{"tabname": "ControlCentre", "data": "controlcenter_assign_revoke_grid"}'
          >
            {loader ? (
              <SkeletonDataTable numSkeletons={25} />
            ) : (
              <DataTable
                value={assignPermission}
                rowGroupMode="subheader"
                groupRowsBy="parent_resource_name"
                sortMode="single"
                sortField="parent_resource_name"
                rowGroupHeaderTemplate={headerTemplate}
                className="control-centre-table"
                tableStyle={{ minWidth: "100%" }}
              >
                <Column
                  field="resource_key"
                  header="Parent Resource Name"
                  style={{ width: "40%", paddingLeft: "48px" }}
                ></Column>
                <Column
                  field="resource_name"
                  header="Resource Name"
                  style={{ width: "20%" }}
                ></Column>
                <Column
                  field="display"
                  header="View"
                  body={revokeGridTemplate}
                  style={{ width: "10%", textAlign: "center" }}
                ></Column>
                <Column
                  field="edit"
                  header="Editable"
                  body={revokeGridBodyTemplate}
                  style={{ width: "10%", textAlign: "center" }}
                ></Column>
                <Column
                  field="assign_revoke"
                  header="+/-"
                  body={RevokeTemplate}
                  style={{ width: "20%", textAlign: "center" }}
                ></Column>
              </DataTable>
            )}
          </div>
        </div>
      </div>

      <Dialog
        visible={categoryPopup}
        onHide={() => setCategoryPopup(false)}
        className="modal-small"
        header="Assign permission"
        draggable={false}
      >
        <div>
          <div className="d-flex justify-content-between">
            <div className="w50">Selected permission key to assign:</div>
            <div style={{ fontWeight: "bold" }} className="w50">
              {popupData?.resource_key} 
            </div>
          </div>
          <div className="d-flex gap-2 mt-3"> 
            <div className="w45"> 
              <MultiSelect
                placeholder="Users"
                options={User}
                optionLabel="user_display_name"
                value={popupDataSelected?.users}
                onChange={(e) => {
                  handlePopupUserSelected(e, true);
                }}
                filter
                filterInputAutoFocus
                panelHeaderTemplate={(options) =>
                  PanelHeaderTemplate(
                    options,
                    "users",
                    popupDataSelected?.users,
                    () => handleClose("users")
                  )
                }
              />
            </div>
            <span className="w10 text-center">or</span>
            <div className="w45">
              <MultiSelect
                placeholder="Category"
                options={usercategory}
                optionLabel="user_category_name"
                value={popupDataSelected?.categories}
                onChange={(e) => {
                  handlePopupUserSelected(e, false);
                }}
                filter
                filterInputAutoFocus
                panelHeaderTemplate={(options) =>
                  PanelHeaderTemplate(
                    options,
                    "categories",
                    popupDataSelected?.categories,
                    () => handleClose("category")
                  )
                }
              />
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center mt-3">
            <button
              className="btn-default"
              onClick={() => setCategoryPopup(false)}
            >
              Cancel
            </button>
            <button className="btn-primary" onClick={() => handlePopupSave()}>
              Save
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
